/** Sidebar en Aanvragen: poll opnieuw na wijziging. */
export const MDR_UNREAD_REFRESH = "mdr-unread-refresh";
